import { render } from "./SubmitChallenge.vue?vue&type=template&id=1089e2e2&scoped=true"
import script from "./SubmitChallenge.vue?vue&type=script&lang=js"
export * from "./SubmitChallenge.vue?vue&type=script&lang=js"

import "./SubmitChallenge.vue?vue&type=style&index=0&id=1089e2e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1089e2e2"]])

export default __exports__